define([
    'edge/platform/base/BaseCtrl',
], (BaseCtrl) => {

    const fn = function ($scope, $state, $stateParams, $translate, lobConfig, LoadSaveService, AvailabilityService, ModalService, $q, LocaleService, ContextService, LoggingService) {

        const ctrl = Object.create(BaseCtrl);
        const lobMap = {MFPLine: 'mfp'};

        ctrl.init = function () {
            LoggingService.setEnableLogging(($stateParams.enableLogging === 'true' || $stateParams.enableLogging === true));

            $scope.moreThanOneLob = lobConfig.lobs.length > 1;

            $scope.activeSection = 'new';

            // populate only the selected zip pane
            function getZip(activeSection) {
                return function () {
                    return $scope.activeSection === activeSection ?
                        $scope.view.postalCode.value
                        : '';
                };
            }


            function setZip(val) {
                $scope.view.postalCode.value = val;
            }

            Object.defineProperties($scope, {
                zipNew: {
                    get: getZip('new'),
                    set: setZip,
                },
                zipRetrieve: {
                    get: getZip('retrieve'),
                    set: setZip,
                },
            });

            //setup locale
            const urlLocale = $stateParams.locale || 'de';
            const currentLocale = LocaleService.getCurrentLocale();
            if (urlLocale !== currentLocale) {
                const { locales } = LocaleService.getLocaleInfo();
                let localeName = locales[urlLocale];
                if (localeName) {
                    LocaleService.setLocaleByDisplayName(localeName);
                } else {
                    localeName = locales.de;
                    LocaleService.setLocaleByDisplayName(localeName);
                }
            }

            $scope.isExistingQuote = false;

            // VehicleType and Channel is specified via url
            ContextService.setMotorcycleMode($stateParams.vehicleType === 'motorcycle');

            if ($stateParams.quoteID) {
                ctrl.goToRetrieveQuote();
            } else {
                ctrl.goToNewQuote();
            }

        };

        // Dcabero: Initial set of the product
        ctrl.selectProduct = function () {
            if ($stateParams.product) {
                return $stateParams.product;
            }

            /*** Temporarily accepting 'channel' as 'product' parameter for compatibility ***/
            if ($stateParams.channel === 'tcs') {
                return 'TCSCombiMotorfahrzeug';
            }

            return 'BaloiseDirectMotorfahrzeug';
        };

        ctrl.selectSubproductInputParam = () => ($stateParams && $stateParams.subproductInputParam) || 'baloise';

        ctrl.selectLob = function () {
            return lobMap.MFPLine;
        };

        ctrl.goToNewQuote = function () {

            const applicantDetails = {
                effectiveDate: new Date(),
                postalCode: $stateParams.postalCode && decodeURIComponent($stateParams.postalCode),
                account: undefined,
                productCode: this.selectProduct(),
                subproductInputParam: this.selectSubproductInputParam(),
                vehicleType: $stateParams.vehicleType,
                empMode: $stateParams.empMode,
                advisorNumber: $stateParams.advisorNumber,
                firstRegistrationYear: $stateParams.firstRegistrationYear,
                firstRegistrationMonth: $stateParams.firstRegistrationMonth,
                uniqueVehicleIdentifier: decodeURIComponent($stateParams.uniqueVehicleIdentifier),
                birthDate: $stateParams.birthDate && decodeURIComponent($stateParams.birthDate),
                nationality: $stateParams.nationality && decodeURIComponent($stateParams.nationality),
                producerForCommissionSplit: decodeURIComponent($stateParams.producerForCommissionSplit),
            };

            $state.go('quoteentry', applicantDetails); //enter quote wizard
        };

        ctrl.goToRetrieveQuote = function () { //NOSONAR compatability with similar code in platform
            $state.go('quoteentry', {
                quoteID: $stateParams.quoteID,
                retrievedByLink: true,
            }); //enter quote wizard
        };

        return ctrl.create($scope);
    };

    fn.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$translate',
        'lobConfig',
        'qnb.LoadSaveService',
        'AvailabilityService',
        'ModalService',
        '$q',
        'LocaleService',
        'ContextService',
        'LoggingService',
    ];

    return fn;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/controllers/BaslerInitialCtrl.js